/**
 * attachment-host-modules.ts — lista slugów modułów-hostów tej iteracji dla klocków
 * palety `attachments_view` (`AttachmentsViewElement`) i `document_preview_view`
 * (`DocumentPreviewViewElement`) — dwa niezależne klocki dzielące IDENTYCZNY zakres
 * hostów, więc lista jest wydzielona tutaj, nie duplikowana w obu plikach.
 *
 * 7 modułów klasy Dokumenty + kontrahenci + użytkownicy + pracownicy. Lista slugów
 * mirroruje `DOCUMENT_MODULE_SLUGS`
 * (`apps/admin/src/pages/system-modules/document-module-slugs.ts`) rozszerzoną
 * o `contractors`/`users`/`employees` — trzymana lokalnie (nie importowana),
 * żeby uniknąć zależności components→pages; źródło prawdy pozostaje
 * `apps/api/lib/seed-system-modules.ts`. Produkty świadomie POMINIĘTE w tej
 * iteracji.
 */

export const ATTACHMENT_HOST_ALLOWED_MODULES = [
  'purchase_invoices',
  'sale_invoices',
  'contracts',
  'letters',
  'commercial',
  'internal',
  'specjalne',
  'contractors',
  'users',
  'employees',
];
